import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'
import { recoilKey } from './index'

const { persistAtom } = recoilPersist({ key: `${recoilKey}-PUBLIC` })

export const publicBookmarksViewMode = atom({
  key: 'publicBookmarksViewMode',
  default: {
    viewLikeCard: true,
    showUrl: true,
    showDescription: true,
  },
  effects_UNSTABLE: [persistAtom],
})

export const publicBookmarksSearchMode = atom({
  key: 'publicBookmarksSearchMode',
  default: {
    title: true,
    description: true,
    url: true,
    text: false,
  },
  effects_UNSTABLE: [persistAtom],
})

export const publicBookmarksSortMode = atom({
  key: 'publicBookmarksSortMode',
  default: '-createdAt',
  effects_UNSTABLE: [persistAtom],
})
